import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import Popover from 'modules/core/components/PopoverMenu'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCancelUploadProcess } from 'modules/documents/hooks/useCancelUploadProcess'
import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'

interface Props {
  uploadProcess: UploadProcess
  onSubmit?: () => void
}

const CancelUploadProcess = ({ uploadProcess, onSubmit }: Props) => {
  const { cancelUploadProcess, loading } = useCancelUploadProcess()
  const [openCancelUploadProcessModal, toggleOpenCancelUploadProcessModal] = useToggle(false)

  const onSubmitHandler = async () => {
    const result = await cancelUploadProcess({ id: uploadProcess.id })

    const handled = handleResult(result, () => null)

    if (handled.success) {
      onSubmit && onSubmit()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('split_documents.upload_process.cancel_modal.error_message'),
      })
    }
  }

  return (
    <>
      <Popover type="list">
        <Popover.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </Popover.Trigger>
        <Popover.Content side="top" align="end">
          <Popover.TouchableOption
            icon="delete"
            onClick={toggleOpenCancelUploadProcessModal(true)}
            title={i18n.t('split_documents.cancel_upload_process.confirm.delete_option')}
            danger
          />
        </Popover.Content>
      </Popover>

      {openCancelUploadProcessModal && (
        <Modal
          illustration="alert"
          title={i18n.t('split_documents.cancel_upload_process.confirm.title')}
          description={i18n.t('split_documents.cancel_upload_process.confirm.description')}
          onClose={toggleOpenCancelUploadProcessModal(false)}
          onSubmit={onSubmitHandler}
          footer={
            <>
              <Button
                type="secondary"
                onClick={toggleOpenCancelUploadProcessModal(false)}
                disabled={loading}
              >
                {i18n.t('common.cancel')}
              </Button>
              <Button type="negative" submit disabled={loading}>
                {i18n.t('split_documents.cancel_upload_process.confirm.button_label')}
              </Button>
            </>
          }
        />
      )}
    </>
  )
}

export default CancelUploadProcess
